import React from 'react';
import '../styles/about.css';
import '../styles/sections.css';

const About = () => {
  return (
    <div className="about-section">
        <div className="section-header">
            <h2>ABOUT ME</h2>
            <div className="underline"></div>
        </div>
        <p>
          I am a passionate and driven Software Developer with a Bachelor of Science in Software Development from Grand Canyon University. 
          My expertise spans full-stack development, with strong proficiency in C#, Java, JavaScript, TypeScript, Dart, and modern frameworks 
          such as React, Angular, Node.js, ASP.NET, and Flutter. I have hands-on experience building scalable applications, REST APIs, and 
          real-time systems using technologies like MySQL, Firebase, MongoDB, AWS, and Azure. I take pride in developing innovative solutions, 
          whether it’s creating mobile and web applications like DevHive, or delivering feature-rich platforms like Notify and Minesweeper. 
          With a foundation in Agile Scrum practices, cloud deployment, and OOP principles, I am committed to writing efficient, maintainable 
          code and collaborating with teams to drive software excellence. My focus is on building intuitive, impactful solutions that solve real-world 
          problems and enhance user experiences.
        </p>
    </div>
  );
};

export default About;